import { render, staticRenderFns } from "./OrderFieldEdit.vue?vue&type=template&id=651d38c4&scoped=true"
import script from "./OrderFieldEdit.vue?vue&type=script&lang=js"
export * from "./OrderFieldEdit.vue?vue&type=script&lang=js"
import style0 from "./OrderFieldEdit.vue?vue&type=style&index=0&id=651d38c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651d38c4",
  null
  
)

export default component.exports